import {
  WeekRegistrationFilters,
  WeekRegistrationKPIEnum,
} from '../../app/flock/models/flock.model';

export const DEFAULT_WEEK_REGISTRATION_FILTERS = {
  kpiFilters: [
    WeekRegistrationKPIEnum.MortalityRate,
    WeekRegistrationKPIEnum.RateOfLay,
    WeekRegistrationKPIEnum.AverageEggWeight,
    WeekRegistrationKPIEnum.AverageEggWeightPerLayerPerDay,
    WeekRegistrationKPIEnum.FeedConsumptionPerLayerPerDay,
    WeekRegistrationKPIEnum.FeedConsumptionPerLayerInProduction,
    WeekRegistrationKPIEnum.WaterToFeedRatio,
    WeekRegistrationKPIEnum.FeedToEggRatio,
    WeekRegistrationKPIEnum.FeedConversionRate,
  ],
  manualInput: [
    WeekRegistrationKPIEnum.AverageLayerWeight,
    WeekRegistrationKPIEnum.MortalityCount,
    WeekRegistrationKPIEnum.TotalEggCount,
    WeekRegistrationKPIEnum.TotalEggCountSecondGrade,
    WeekRegistrationKPIEnum.WaterConsumption,
    WeekRegistrationKPIEnum.FeedConsumption,
    WeekRegistrationKPIEnum.SecondFeedConsumption,
  ],
  isMoultSelected: true,
  isRemarksSelected: true,
} as WeekRegistrationFilters;

export const BREEDER_REGISTRATION_COLUMNS = [
  { parameter: 'HenMortality', decimals: 0, unit: '' },
  { parameter: 'RoosterMortality', decimals: 0, unit: '' },
  { parameter: 'HenWeight', decimals: 2, unit: 'g' },
  { parameter: 'RoosterWeight', decimals: 2, unit: 'g' },
  { parameter: 'HenFeedIntakeInGrams', decimals: 2, unit: 'g' },
  { parameter: 'RoosterFeedIntakeInGrams', decimals: 2, unit: 'g' },
  { parameter: 'HenWaterIntakeInLiters', decimals: 2, unit: 'l' },
  { parameter: 'RoosterWaterIntakeInLiters', decimals: 2, unit: 'l' },
  { parameter: 'TotalFeedPerWeek', decimals: 2, unit: 'kg' },
  { parameter: 'WaterInLiters', decimals: 2, unit: 'l' },
  { parameter: 'EggCount', decimals: 0, unit: '' },
  { parameter: 'HatchingEggCount', decimals: 0, unit: '' },
  { parameter: 'EggWeightInGrams', decimals: 2, unit: 'g' },
  { parameter: 'FertilityPercentage', decimals: 1, unit: '%' },
  { parameter: 'HatchPercentage', decimals: 1, unit: '%' },
  { parameter: 'LightHours', decimals: 2, unit: 'h' },
  { parameter: 'LightIntensity', decimals: 2, unit: 'lux' },
] as const;

export const BREEDER_REGISTRATION_PARAMETERS: string[] = BREEDER_REGISTRATION_COLUMNS.map(
  ({ parameter }) => parameter,
);

export const DEFAULT_BREEDER_WEEK_REGISTRATION_FILTERS: WeekRegistrationFilters = {
  kpiFilters: [
    'HenCount',
    'RoosterCount',
    'RoosterPercentage',
    'RateOfLay',
    'AverageEggWeight',
    'EggMassPerBreeder',
    'FeedPerBreeder',
    'FeedPerBreederPerDay',
    'FeedPerHatchedEgg',
    'FeedToEggRatio',
    'FeedConversion',
    'WaterToFeedRatio',
    'MortalityRate',
    'ProductionFigure',
    'HatchedEggsPerPlacedHen',
    'EggsPerPlacedHen',
    'HenMortalityRate',
    'RoosterMortalityRate',
    'HatchedEggsCumulative',
    'HatchPercentageCumulative',
    'RateOfLayCumulative',
    'AverageEggWeightCumulative',
    'EggMassPerBreederCumulative',
    'FeedPerBreederCumulative',
    'FeedPerBreederPerDayCumulative',
    'FeedPerHatchedEggCumulative',
    'FeedToEggRatioCumulative',
    'FeedConversionCumulative',
    'WaterToFeedRatioCumulative',
    'MortalityRateCumulative',
    'HatchedEggsPerPlacedHenCumulative',
    'EggsPerPlacedHenCumulative',
    'HenMortalityRateCumulative',
    'RoosterMortalityRateCumulative',
  ],
  manualInput: [...BREEDER_REGISTRATION_PARAMETERS],
};

export const ALL_WEEK_REGISTRATION_FILTERS = {
  kpiFilters: [
    WeekRegistrationKPIEnum.MortalityRate,
    WeekRegistrationKPIEnum.MortalityRateCumulative,
    WeekRegistrationKPIEnum.RateOfLay,
    WeekRegistrationKPIEnum.AverageEggWeight,
    WeekRegistrationKPIEnum.AverageEggWeightPerLayerPerDay,
    WeekRegistrationKPIEnum.TotalEggWeight,
    WeekRegistrationKPIEnum.TotalEggWeightPerLayerInProductionCumulative,
    WeekRegistrationKPIEnum.EggCountPerLayerInProduction,
    WeekRegistrationKPIEnum.EggCountPerLayerInProductionCumulative,
    WeekRegistrationKPIEnum.FeedConsumptionPerLayerPerDay,
    WeekRegistrationKPIEnum.FeedConsumptionPerLayerInProduction,
    WeekRegistrationKPIEnum.FeedConsumptionPerLayerInProductionCumulative,
    WeekRegistrationKPIEnum.FeedConsumptionPerLayerPerDayCumulative,
    WeekRegistrationKPIEnum.WaterToFeedRatio,
    WeekRegistrationKPIEnum.FeedToEggRatio,
    WeekRegistrationKPIEnum.FeedConversionRate,
    WeekRegistrationKPIEnum.FeedConversionRateCumulative,
  ],
  manualInput: [
    WeekRegistrationKPIEnum.AverageLayerWeight,
    WeekRegistrationKPIEnum.MortalityCount,
    WeekRegistrationKPIEnum.TotalEggCount,
    WeekRegistrationKPIEnum.TotalEggCountSecondGrade,
    WeekRegistrationKPIEnum.FeedConsumption,
    WeekRegistrationKPIEnum.SecondFeedConsumption,
    WeekRegistrationKPIEnum.WaterConsumption,
  ],
} as WeekRegistrationFilters;
